import React, { useContext, useEffect, useState } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import UserContext from '../user/UserContext';
import LoadingSpinner from '../common/LoadingSpinner';
import { useAlert } from 'react-alert';

export default function FranchiseRedirect() {
    const [redirectReady, setRedirectReady] = useState(false);
    const { userDetails, updateCurrentFranchise } = useContext(UserContext);
    const params = useParams();
    const franchiseCode = params.franchiseCode;
    const alert = useAlert();

    useEffect(() => {
        // Wait for userDetails to be populated before trying to redirect
        if (userDetails.currentFranchise) {
            if (userDetails.currentFranchise.code !== franchiseCode) {
                const matchedFranchises = userDetails.allFranchises.filter(
                    franchise => franchise.code === franchiseCode
                );
                if (matchedFranchises.length === 1) {
                    updateCurrentFranchise(matchedFranchises[0]);
                } else {
                    alert.error('Franchise: ' + franchiseCode + ' is not viewable.');
                }
            }
            setRedirectReady(true);
        }
        // eslint-disable-next-line
    }, [userDetails, franchiseCode, updateCurrentFranchise]);
    return redirectReady ? <Redirect to={'/'} /> : <LoadingSpinner />;
}
